import { gql } from '@grandvisionhq/graphql';
import { cartDetails } from '../fragments/cart-details.js';
import { unknownLoyaltyDetailsFailure } from '../fragments/loyalty-point-failure.js';

const SET_LOYALTY_DETAILS = gql`
  mutation SetLoyaltyDetails($input: LoyaltyDetailsInput!) {
    setLoyaltyDetails(input: $input) {
      success
      message
      cart {
        ...CartDetailsFragment
      }
      failures {
        ...UnknownSetLoyaltyDetailsFailureFragment
      }
    }
  }
  ${cartDetails}
  ${unknownLoyaltyDetailsFailure}
`;

export { SET_LOYALTY_DETAILS };
//# sourceMappingURL=set-loyalty-details.js.map
